export default __webpack_public_path__ + "static/media/x-circle.72ade313.svg";